import React from 'react';

import { LayoutSingleColumn, NamedLink, Page } from '../../components';
import FooterContainer from '../FooterContainer/FooterContainer';
import TopbarContainer from '../TopbarContainer/TopbarContainer';

import css from './FaqPage.module.css';

const clientQuestions = [
  {
    question: 'What is Hotline Glam?',
    answer:
      'Hotline Glam helps clients find Sydney makeup artists, compare portfolios and prices, and send a booking request in one place.',
  },
  {
    question: 'How do I request a booking?',
    answer:
      'Choose your date and preferred time, browse Sydney artists, select the artist you want and send your booking request with the appointment details.',
  },
  {
    question: 'When will I be charged?',
    answer:
      'You enter your payment details when sending the request, but payment is only processed after the artist accepts the booking.',
  },
  {
    question: 'How long does an artist have to respond?',
    answer:
      'Artists have a 30-minute acceptance window to accept or decline a booking request. You will be updated when the artist responds.',
  },
  {
    question: 'What happens if the requested time does not work?',
    answer:
      'The artist may decline the request if the appointment time does not suit them. You can then send a new request to another artist.',
  },
  {
    question: 'When is the full address shared?',
    answer:
      'Only the suburb is shown before booking. The exact appointment address is shared after the booking has been accepted.',
  },
  {
    question: 'What happens if an artist does not attend?',
    answer:
      'Use the Report a problem option within 24 hours of the appointment. Hotline Glam reviews the report before any refund is issued.',
  },
];

const artistQuestions = [
  {
    question: 'Does it cost anything to join as an artist?',
    answer:
      'There is no upfront cost to create an artist account or publish a listing. Hotline Glam receives a 10% commission only when a booking is completed.',
  },
  {
    question: 'Can I offer studio and mobile appointments?',
    answer:
      'Yes. You can offer studio appointments, mobile appointments, or both. If you offer mobile services, there is a dedicated section to set your travel fee and the distance you’re willing to travel.',
  },
  {
    question: 'When do artists receive their payout?',
    answer:
      'Hotline Glam releases the payout 48 hours after the appointment is completed. Stripe then transfers the funds to the artist’s connected bank account, and normal bank processing times may apply.',
  },
];

const QuestionGroup = ({ title, questions }) => (
  <section className={css.group} aria-labelledby={`${title.toLowerCase().replace(' ', '-')}-heading`}>
    <h2 id={`${title.toLowerCase().replace(' ', '-')}-heading`}>{title}</h2>
    <div className={css.questions}>
      {questions.map(item => (
        <details className={css.question} key={item.question}>
          <summary>{item.question}</summary>
          <p>{item.answer}</p>
        </details>
      ))}
    </div>
  </section>
);

const FaqPage = () => (
  <Page
    title="Frequently Asked Questions | Hotline Glam"
    description="Answers to common questions about booking a Sydney makeup artist or joining Hotline Glam as an artist."
  >
    <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
      <main id="main-content" className={css.page}>
        <div className={css.content}>
          <header className={css.header}>
            <h1>Frequently Asked Questions</h1>
          </header>

          <QuestionGroup title="For clients" questions={clientQuestions} />
          <QuestionGroup title="For artists" questions={artistQuestions} />

          <section className={css.contact}>
            <div>
              <h2>Still need help?</h2>
              <p>Send us your question and include your booking reference when it relates to a booking.</p>
            </div>
            <NamedLink name="ContactPage" className={css.contactButton}>
              Contact Hotline Glam
            </NamedLink>
          </section>
        </div>
      </main>
    </LayoutSingleColumn>
  </Page>
);

export default FaqPage;
